function initPaymentMessagingSlider(selector = '.product__blocks') {
  const roots = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector].filter(Boolean);

  roots.forEach((root) => {
    if (!(root instanceof Element)) return;
    initPaymentMessagingSliderForRoot(root);
  });
}

function initPaymentMessagingSliderForRoot(root, attempt = 0) {
  if (root.dataset.paymentMessagingSlider === 'true') return;

  const klarnaBlock = findPaymentProductBlock(root, 'klarna');
  const clearpayBlock = findPaymentProductBlock(root, 'clearpay');

  if (!klarnaBlock || !clearpayBlock) {
    if (attempt < 20) {
      setTimeout(() => initPaymentMessagingSliderForRoot(root, attempt + 1), 250);
    }
    return;
  }

  root.dataset.paymentMessagingSlider = 'true';

  const orderedBlocks = [klarnaBlock, clearpayBlock].sort((a, b) =>
    a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
  );

  const slider = document.createElement('div');
  slider.className = 'payment-messaging-slider product__block swiper';
  slider.innerHTML =
    '<div class="swiper-wrapper"></div><div class="swiper-pagination payment-messaging-slider__pagination"></div>';

  const wrapper = slider.querySelector('.swiper-wrapper');
  orderedBlocks[0].before(slider);

  orderedBlocks.forEach((block) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(block);
    wrapper.appendChild(slide);
  });

  const carousel = new FoxTheme.Carousel(
    slider,
    {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
      },
    },
    [FoxTheme.Swiper.Autoplay]
  );

  carousel.init();

  if (typeof injectKlarnaStyles === 'function') {
    const scopedSelector = root.id ? `#${root.id}` : '.product__blocks';
    const parent = root.closest('quick-view-modal, product-info');
    const selector = parent?.id ? `#${parent.id} .product__blocks` : scopedSelector;
    injectKlarnaStyles(selector);
  }
}

function findPaymentProductBlock(root, keyword) {
  const pattern = new RegExp(keyword, 'i');

  return Array.from(root.children).find((block) => {
    if (!block.classList.contains('product__block')) return false;

    return Array.from(block.children).some((child) => child.id && pattern.test(child.id));
  });
}

window.initPaymentMessagingSlider = initPaymentMessagingSlider;
